module.exports = __webpack_public_path__ + "img/coround.e153062.webp";